import AudioPlayerContext, { type AudioPlayerContextType } from './AudioPlayerContext';
import * as React from 'react';

const useAudioPlayer = (): AudioPlayerContextType => {
	const context = React.useContext(AudioPlayerContext);
	if (!context) {
		throw new Error('useAudioPlayer must be used within an AudioPlayerProvider');
	}
	return context;
};

export default useAudioPlayer;
